import React from 'react';
import {
  WrapperStyle,
  DescriptionStyle,
  Title,
  SeparatorStyle,
} from '../../resources/styling/surveyReportStyle';
import ReportScores from './ReportScores';
import RoleWiseReportScores from './RoleWiseReportScores';
import SuggestedPriorityActionsView from './SuggestedPriorityActionsView';
import {
  limitAverageValue,
  scoreNotAvailableValue,
} from '../../utils/roundScore';
import {
  ViewIndividualAnswers,
  AreasForReviewAndPossibleFocus,
} from './Constants';
import ReportResultsSection from './ReportResultsSection';
import { useTranslation } from 'react-i18next';

const ChangeReport = ({ report, onButtonClick, isPaid }) => {
  const { t } = useTranslation();
  const {
    ResultsText,
    HseStrengths,
    HseWeaknesses,
    SchoolStrengths,
    SchoolWeaknesses,
    SuggestedPriorityActions,
    Score,
  } = report;
  return (
    <WrapperStyle>
      <h1 className='report-title'>{isPaid ? 6 : 7}. Change</h1>
      <p id='changeTitle'>
        How changes at school (large or small) are managed and communicated to
        all staff and stakeholders.
      </p>
      <button data-test-id='changeReport' onClick={onButtonClick}>
        {ViewIndividualAnswers}
      </button>
      <p id='demandsTitle' style={{ 'text-align': 'center' }}>
        Overall Scores and Deciles
      </p>
      <ReportScores
        Score={Score}
        id='changeScore'
        className='report-score change-score'
        isPaid={isPaid}
      />
      {scoreNotAvailableValue(
        limitAverageValue(Score.SupportStaffClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(
        limitAverageValue(Score.SupportStaffNonClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(
        limitAverageValue(Score.TeachingStaffClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(
        limitAverageValue(Score.TeachingStaffNonClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(limitAverageValue(Score.MiddleLeaderCatAvg)) ===
        '-1.00' &&
      scoreNotAvailableValue(limitAverageValue(Score.SeniorLeaderCatAvg)) ===
        '-1.00' ? (
        ''
      ) : (
        <>
          <br />
          <p id='demandsTitle' style={{ 'text-align': 'center' }}>
            Scores by Job Role
          </p>
          <RoleWiseReportScores
            Score={Score}
            id='RoleWisechangeScore'
            className='report-score'
          />
        </>
      )}
      <DescriptionStyle id='changeDescription'>
        <h1 className='report-list-wrapper'>Description</h1>
        <Title className='description-title'>
          The Management Standard is that:
        </Title>
        <ul className='report-list-wrapper'>
          <li>
            Staff indicate that the school engages them frequently when
            undergoing an {t('organisational')} change.
          </li>
          <li>
            Systems are in place locally to respond to any individual concerns.
          </li>
        </ul>
        <Title className='description-title'>
          This means that where possible:
        </Title>
        <ul className='report-list-wrapper'>
          <li>
            The school provides staff with timely information to enable them to
            understand the reasons for proposed changes.
          </li>
          <li>
            The school ensures adequate staff consultation on changes and
            provides opportunities for them to influence proposals.
          </li>
          <li>
            Staff are aware of the probable impact of any changes to their jobs.
            If necessary, they are given training to support any changes in
            their jobs.
          </li>
          <li>Staff are aware of timetables for changes.</li>
          <li>Staff have access to relevant support during changes.</li>
        </ul>
      </DescriptionStyle>

      {isPaid ? (
        <div>
          <SeparatorStyle />
          <ReportResultsSection
            id='changeResults'
            ResultsText={ResultsText}
            SchoolStrengths={SchoolStrengths}
            SchoolWeaknesses={SchoolWeaknesses}
            HseStrengths={HseStrengths}
            HseWeaknesses={HseWeaknesses}
            AreasForReviewAndPossibleFocus={AreasForReviewAndPossibleFocus}
          />
        </div>
      ) : null}

      {isPaid ? (
        <div>
          <SeparatorStyle />
          <SuggestedPriorityActionsView
            id='changeSuggestions'
            heading='Suggested Priority Actions for Change'
            SuggestedPriorityActions={SuggestedPriorityActions}
          />
        </div>
      ) : null}
      <div id='next-steps' />
    </WrapperStyle>
  );
};

export default ChangeReport;
